import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LocalStorageKeyConstants } from "./constants";
import { useAuth } from "./context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      const currentPath = location.pathname + location.search + location.hash;
      if (currentPath !== "/login" && currentPath !== "/logout") {
        localStorage.setItem(
          LocalStorageKeyConstants.REDIRECT_PATH,
          currentPath
        );
      }
    }
  }, [isLoggedIn, location]);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
